import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/images/vue-logo.png'
import _imports_1 from './assets/images/bulma-logo.png'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "container is-fluid" }
const _hoisted_3 = {
  id: "nav",
  class: "tabs is-centered is-small"
}
const _hoisted_4 = { id: "main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBarBrand = _resolveComponent("NavBarBrand")!
  const _component_NavTab = _resolveComponent("NavTab")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavBarBrand),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", null, [
          _createVNode(_component_NavTab, {
            text: "Home",
            img: "home",
            uri: "/"
          }),
          _createVNode(_component_NavTab, {
            text: "Work",
            img: "folder",
            uri: "/work"
          }),
          _createVNode(_component_NavTab, {
            text: "News",
            img: "newspaper",
            uri: "/news"
          }),
          _createVNode(_component_NavTab, {
            text: "Contact",
            img: "envelope",
            uri: "/contact"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_view)
      ])
    ]),
    _cache[0] || (_cache[0] = _createStaticVNode("<footer class=\"footer\"><div class=\"content has-text-centered\"><p> Handcrafted by me.<br><a href=\"http://geoffrey.lalloue.fr\">geoffrey.lalloue.fr</a><br> Powered with <img alt=\"Vue logo\" src=\"" + _imports_0 + "\"> Vue.js 3 &amp; <img alt=\"Bulma logo\" src=\"" + _imports_1 + "\"> Bulma </p></div></footer>", 1))
  ]))
}